export const Marquee = ({ items, testId = "club-marquee" }) => {
  const row = items.map((item, i) => (
    <span key={i} className="inline-flex items-center gap-6 mx-6 whitespace-nowrap">
      <span className="font-head font-extrabold uppercase tracking-[0.15em] text-sm sm:text-base text-[#F7F5F0]/90">{item}</span>
      <span className="w-2 h-2 rounded-full bg-[#E5AC3C] inline-block" aria-hidden="true" />
    </span>
  ));
  return (
    <div className="relative overflow-hidden border-y border-[#E5AC3C]/25 bg-[#0E1A29] py-4" data-testid={testId} aria-hidden="true">
      <div className="flex w-max animate-club-marquee">
        <div className="flex">{row}</div>
        <div className="flex">{row}</div>
      </div>
    </div>
  );
};
